import _ from 'lodash';

/*
 Function: getAssessments

 Parameters:
  skills - flat array of skills
  clonedAssessmentTypes - set of assessments to evaluate
  filterBySkillCategory - bool indicating if the skillCategory is taken into account or not

*/
export function getAssessments(skills, clonedAssessmentTypes, filterBySkillCategory) {
  const filterSkills = (categoryId, maxLastUsed = 7) => {
    const skillsWithValues = _.filter(skills, skill => skill.name !== 'None');
    const validSkills = _.filter(skillsWithValues, skill => (_.get(skill, 'lastUsed', 999) <= maxLastUsed || _.get(skill, 'lastUsed') === 100));
    const skillsInCategory = filterBySkillCategory === true ? _.filter(validSkills, skill => skill.categoryId === categoryId) : validSkills;
    return skillsInCategory.map(skill => skill.name);
  };

  // filtering functions
  const fns = {
    has: (skillCategory, reqSkills, assessment) => {
      const filteredSkills = filterSkills(skillCategory, assessment.maxLastUsed);
      return _.intersection(filteredSkills, reqSkills).length === reqSkills.length;
    },
    hasNot: (skillCategory, reqSkills, assessment) => {
      const filteredSkills = filterSkills(skillCategory, assessment.maxLastUsed);
      return _.intersection(filteredSkills, reqSkills).length === 0;
    },
    any: () => true,
    atLeastOne: (skillCategory, requiredSkills, assessment) => {
      const filteredSkills = filterSkills(skillCategory, assessment.maxLastUsed);
      return _.intersection(filteredSkills, requiredSkills).length > 0;
    }
  };

  // evaluates filtering functions to determine if the assessment is required for the applicant
  // returns true if all assessment display criteria are met
  const showDisplay = (assessment) => {
    return assessment.display.every((param) => {                        // ensure that all filters evaluate to true
      const reqSkills = param.parameters;                               // skills
      const skillCategory = Number.parseInt(param.skillCategoryId, 10); // category
      const action = param.action;                                      // name of filter function
      const skill = fns[action](skillCategory, reqSkills, assessment);         // evaluate filter
      return skill;
    });
  };

  const assessments = clonedAssessmentTypes.map(assessment => {
    assessment.display = showDisplay(assessment);
    return assessment;
  });

  return assessments;
}



// WEBPACK FOOTER //
// ./shared/utils/assessmentRules.js